import join from 'url-join';
import { ArticleFragmentResponse } from '../../../../fragments/article';
import useSiteMetadata from '../../../Seo/useSiteMetadata';
import { BREADCRUMB_HASH } from './useBreadcrumbListObject';
import { PRIMARY_IMAGE_HASH } from './useImageObject';

export const WEBPAGE_HASH = '#webpage';

const useWebpageObject = (article: ArticleFragmentResponse) => {
  const { siteUrl } = useSiteMetadata();
  const { title, subtitle, slug, category } = article;

  if (slug?.current && category?.slug?.current) {
    return {
      '@type': 'WebPage',
      '@id': join(siteUrl, slug.current, WEBPAGE_HASH),
      url: siteUrl,
      name: title,
      description: subtitle,
      isPartOf: {
        '@type': 'WebPage',
        '@id': join(siteUrl, category.slug.current, WEBPAGE_HASH),
      },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        '@id': join(siteUrl, slug?.current, PRIMARY_IMAGE_HASH),
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        '@id': join(siteUrl, slug?.current, BREADCRUMB_HASH),
      },
    };
  }
};

export default useWebpageObject;
